import { __assign } from 'tslib';
import React, { forwardRef } from 'react';
import { SelectMobile } from './Component.mobile.js';
import '../../../bottom-sheet/esm';
import '../../../form-control/esm/mobile';
import '../../../modal/esm/mobile';
import '../components/arrow/Component.js';
import 'classnames';
import '@alfalab/icons-glyph/ChevronDownMIcon';
import '../components/base-select/Component.js';
import 'react-merge-refs';
import '@juggle/resize-observer';
import 'compute-scroll-into-view';
import 'downshift';
import '../../../shared/esm';
import '@alfalab/hooks';
import '../components/native-select/Component.js';
import '../components/field/Component.js';
import '../components/footer/Component.js';
import '../../../base-modal/esm';
import '../../../button/esm/mobile';
import '../components/optgroup/Component.js';
import '../components/option/Component.js';
import '../components/checkmark/Component.js';
import '../../../badge/esm';
import '../../../checkbox/esm';
import '@alfalab/icons-glyph/CheckmarkCircleMIcon';
import '@alfalab/icons-glyph/CheckmarkMIcon';
import '../components/checkmark-mobile/Component.js';
import '../components/options-list/Component.js';
import '../../../mq/esm';
import '../../../scrollbar/esm';
import '../components/search/Component.js';
import '../../../input/esm';
import '@alfalab/icons-glyph/MagnifierMIcon';
import '../components/virtual-options-list/Component.js';
import 'react-virtual';
import '../hook-0d643e3f.js';
import '../presets/useSelectWithApply/options-list-with-apply/footer/Component.js';
import '../../../button/esm/desktop';
import '../presets/useSelectWithApply/options-list-with-apply/header/Component.js';
import '../utils.js';
import '../consts.js';

var SelectModalMobile = forwardRef(function (props, ref) { return (React.createElement(SelectMobile, __assign({}, props, { isBottomSheet: false, ref: ref }))); });

export { SelectModalMobile };
